jQuery(function($){
  function stickyHeader() {
    if ($(window).scrollTop() > 100) {
      $('.header').addClass('is-sticky');
    } else {
      $('.header').removeClass('is-sticky');
    }
  }
  
    $("#nav-icon1").off("click").on("click", function () {
      $(this).toggleClass("open");
      $(".main-menu-wrap").slideToggle();
    });


    stickyHeader();
    
    $(window).on('scroll', function() {
        stickyHeader();
    });
  
});
